import { has } from 'lodash-es'
import 'dayjs/locale/fr'
import 'antd/dist/reset.css'
import '@public/antd.min.css'
import './index.css'

import { ConfigProvider } from 'antd'
import { StyleProvider } from '@ant-design/cssinjs'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { Provider as UrqlProvider } from 'urql'
import { ErrorBoundary } from './sentry/ErrorBoundary'
import { ErrorFallback } from './sentry/ErrorFallback'

import { QueryClientProvider } from '@tanstack/react-query'

import { queryClient } from '@/lib/queryClient'
import { urqlClient } from '@/lib/urqlClient'
import { ANTD_HASH_PRIORITY, theme } from 'src/utils/theme'
import { router } from './router'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)
dayjs.tz.setDefault('Europe/Paris')
dayjs.locale('Europe/Paris')

if (
  typeof window !== 'undefined' &&
  has(window, 'Cypress') &&
  has(window, 'queryClient')
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).queryClient = queryClient
}

const App: React.FC = () => {
  return (
    <ErrorBoundary
      fallback={({ reference, reset }) => (
        <ErrorFallback reference={reference} onRetry={reset} />
      )}
    >
      <UrqlProvider value={urqlClient}>
        <QueryClientProvider client={queryClient}>
          {/* Same priority as the extracted `antd.min.css`: see ANTD_HASH_PRIORITY. */}
          <StyleProvider hashPriority={ANTD_HASH_PRIORITY}>
            <ConfigProvider theme={theme}>
              <RouterProvider router={router} />
            </ConfigProvider>
          </StyleProvider>
        </QueryClientProvider>
      </UrqlProvider>
    </ErrorBoundary>
  )
}

export default App
